import { render, staticRenderFns } from "./CompareMatches.vue?vue&type=template&id=4e45811c&scoped=true&"
import script from "./CompareMatches.vue?vue&type=script&lang=js&"
export * from "./CompareMatches.vue?vue&type=script&lang=js&"
import style0 from "./CompareMatches.vue?vue&type=style&index=0&id=4e45811c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45811c",
  null
  
)

export default component.exports